export var ZOOM_ANIMATION = {
    duration: 200,
    checkZoomRange: true,
    useMapMargin: true
};
export var CENTER_ANIMATION = {
    duration: 450,
    checkZoomRange: true,
    useMapMargin: true
};
export var BOUNDS_ANIMATION = {
    duration: 450,
    checkZoomRange: true,
    useMapMargin: true
};
